import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Arkar Kaung Myat`}</h1>
    <p>{`An inspiring front-end developer who loves  problem solving and design .`}</p>
    <h5>{`I code`}</h5>
    <h6>{`HTML & CSS / SCSS & SASS`}</h6>
    <h6>{`React & Redux / React native / NextJS / Gatsby`}</h6>
    <h6>{`TailwindCSS`}</h6>
    <h6>{`Python / Django`}</h6>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      